import { render, staticRenderFns } from "./person-item.vue?vue&type=template&id=3edaf48e&"
import script from "./person-item.vue?vue&type=script&lang=tsx&"
export * from "./person-item.vue?vue&type=script&lang=tsx&"
import style0 from "./person-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports